import { css } from '@emotion/react'
import {
  baseColor,
  secondaryGrayColor,
  linkColor,
  linkHoverColor,
  primaryTextColor
} from './colors'
import { oneDpShadowCss } from './shadows'

export const srOnlyCss = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`

export const centerBlockCss = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`

export const pullRightCss = css`
  float: right;
`

export const linkCss = css`
  color: ${linkColor};
  font-weight: bold;

  &:hover {
    color: ${linkHoverColor};
  }

  /* WCAG 2.4.7: Visible focus indicator for keyboard navigation */
  &:focus-visible {
    color: ${linkHoverColor};
    outline: 2px solid ${baseColor};
    outline-offset: 2px;
    z-index: 1;
  }
`

export const dividerCss = css`
  border-bottom: 1px solid ${secondaryGrayColor};
`

export const dividerTopCss = css`
  border-top: 1px solid ${secondaryGrayColor};
`

export const cardCss = css`
  background-color: #ffffff;
  border-radius: 2px;
  margin-bottom: 40px;
  max-width: 550px;
  padding-bottom: 20px;
  ${oneDpShadowCss};
`

export const planCardCss = css`
  background: #ffffff;
  border-radius: 2px;
  min-height: 170px;
  line-height: 28px;
  text-align: left;
  padding-left: 17px;
  color: ${primaryTextColor};
  text-decoration: none;
`

export const fullPageCardCss = css`
  ${cardCss};
  max-width: unset;
  margin: 20px;
  padding: 30px 20px;

  /* WCAG - Reflow: Reduce margins on narrow viewports to prevent horizontal overflow */
  @media (max-width: 400px) {
    margin: 16px;
    padding: 24px 16px;
  }

  @media (max-width: 320px) {
    /* Ensure card doesn't cause horizontal overflow at 320px width (400% zoom or mobile) */
    margin: 12px 8px;
    padding: 20px 12px;
    box-sizing: border-box;
    /* Prevent any child elements from causing horizontal overflow */
    max-width: 100%;
    overflow-x: hidden;
  }
`

export const standardContainerCss = css`
  margin-bottom: 28px;
  padding: 10px 14px;
`

export const fieldsetCss = css`
  border: none;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-block-start: 0;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-block-end: 0;
`

export const rippleContainerCss = css`
  height: 48px;
  width: 48px;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  z-index: 0;
  margin-top: -12px;
  margin-left: -12px;
  border-radius: 50%;
`
